import accessibilityWidget from "./widget";
import { getScriptDataAttribute } from "./utils/getScriptDataAttribute";
import observeHTMLLang from "./utils/observeHTMLLang";

/**
 * Initializes the accessibility widget
 * @returns void
 */
async function initialize(): Promise<void> {
  try {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      document.removeEventListener('readystatechange', initialize);

      // Initialize the accessibility widget
      await accessibilityWidget();

      // Observe HTML lang attribute changes unless disabled
      if (!getScriptDataAttribute("disableObserveLang")) {
        observeHTMLLang();
      }
    }
  } catch (error) {
    console.error('Failed to initialize accessibility widget:', error);
  }
}

// Use readystatechange for async support
document.addEventListener("readystatechange", initialize);

// Also try to initialize immediately if document is already ready
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initialize();
}

